import styled, { css } from 'styled-components'

export const StyledFormCustomerCost = styled.form`
    ${({ theme, isEdit }) => css`
        grid-template-rows: ${isEdit
            ? `repeat(4, max-content)`
            : `repeat(3, max-content)`};
        grid-gap: ${theme.spacing * 2}px;
        height: 100%;
    `}
`
